<template>
  <section>
    <br>
    <p class="p-style">
      Step 2: Job Status
    </p>
    <div class="user-div">
      <p class="user-content">
        Check-In Location:- <font
          class="font-my-style"
        >
          {{ activeCheckInDetails.site.name }}
        </font>
      </p>
      <p class="user-content">
        Check-In Type:- <font
          class="font-my-style"
        >
          {{ activeCheckInDetails.type }}
        </font>
      </p>
      <p class="user-content">
        Check-Out Location:- <font
          v-if="locationName.site_name !== undefined"
          class="font-my-style"
        >
          {{ locationName.site_name }}
        </font>
        <font v-else>
          N/A
        </font>
      </p>
    </div>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-container fluid>
            <p class="job-number">
              Job Number:- <font
                class="font-my-style"
              >
                {{ activeCheckInDetails.job_details.job_number }}
              </font>
            </p>
            <v-radio-group
              v-model="jobStatus"
              row
              light
              :rules="[(v) => !!v || 'This field is required']"
              @change="isJobStatusChanged"
            >
              <v-radio
                label="Pending"
                value="pending"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Pending</span>
                </template>
              </v-radio>
              <v-radio
                label="Completed"
                value="completed"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Completed</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-textarea
              ref="status"
              v-model="pendingReason"
              dense
              :rules="jobStatus === 'pending' ? [(v) => !!v || 'This field is required'] : []"
              filled
              hint="Only required if Job Status is 'Pending'."
              persistent-hint
              color="#000000"
              light
              :disabled="jobStatus !== 'pending'"
              outlined
              label="Reason*"
            />
            <div v-if="isOrgInvoiceEnabled">
              <p class="invoice-Style">
                Approx Invoice Amount:
              </p>
              <v-text-field
                v-model="invoiceAmount"
                label="Amount"
                type="number"
                dense
                filled
                color="#000000"
                light
                outlined
                class="purple-input"
              />
            </div>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="#37474F"
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="#FF3700"
                @click="jobStatusGathered()"
              >
                Next
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import OrgSettingsHelper from 'src/helpers/org-setting-helper';

export default {
  name: 'GatherJobStatus',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    arrangePretty (val) {
      return val.join(', ');
    },
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    valid: false,
    jobStatus: null,
    pendingReason: null,
    invoiceAmount: null,
    helper: new OrgSettingsHelper(),
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
    isOrgInvoiceEnabled () {
      return (this.helper.isSubModuleExist(Constants.MODULE_WORK_ORDERS, Constants.SUB_MODULE_INVOICE));
    },
  },
  methods: {
    jobStatusGathered () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('swiftuser/saveJobStatus', {
        job_status: this.jobStatus,
        pending_reason: this.pendingReason,
        invoice_amount: this.invoiceAmount,
      });
      setTimeout(() => {
        this.loading = false;
        this.$emit('job-status-stored');
      }, 2000);
    },
    isJobStatusChanged () {
      if (this.jobStatus === 'completed') {
        this.$refs.status.reset();
      }
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.job-number {
  font-size: 16px;
  font-weight: bold;
  margin-left: 3px;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.invoice-Style {
  font-size: 16px;
  font-weight: bold;
  margin-left: 3px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.input__label {
   font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-div {
  line-height:normal;
  border-left: 3px solid #FF3700;
  margin-left: 10px;
}
</style>
